import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
    TextGroup,
    TextGroup2,
    Card,
    Text,
    TextTypes,
    showToast,
    ToastVariants,
} from '../../index';
import { GiftCard } from '../../../types/graphql-global-types';
import CardWrapper from '../card-wrapper';
import CopyIcon from '../../../assets/copy.svg';
import util from '../../../util';
import moment from 'moment';

interface CardDesktopProps {
    card: GiftCard;
    handlePrint?: () => void;
    balance: () => HTMLElement;
    cardImage: () => HTMLElement;
}

const CardDesktop = ({ card, ...props }: CardDesktopProps) => {
    const handleCopy = () => {
        const copied = util.copyToClipboard(card.giftcardnumber || '');
        showToast({
            title: copied ? 'Copied to Clipboard!' : 'Failed to copy!',
            content: '',
            variant: copied ? ToastVariants.SUCCESS : ToastVariants.DANGER,
        });
    };

    return (
        <Card className="order-card">
            <Container fluid>
                <Row>
                    <Col md={4}>
                        <div className="d-flex card-head">
                            <Text type={TextTypes.H4} className="card-name">
                                Card #{card.giftcardnumber}
                            </Text>
                            {props.handlePrint && (
                                <img
                                    alt="copy icon"
                                    src={CopyIcon}
                                    className="copy-icon"
                                    onClick={handleCopy}
                                />
                            )}
                        </div>
                        {props.cardImage()}
                    </Col>
                    <Col />
                    <Col md={7} className="card-info">
                        <Row>
                            <TextGroup2
                                label="Original Card Value"
                                value={'$' + (card.denomination?.toFixed(2) || '')}
                            />
                            <TextGroup2 label="Current Balance" value={props.balance()} />
                            <Col />
                        </Row>
                        <Row>
                            <Col md={4} style={{ padding: 0 }}>
                                <TextGroup
                                    label="Email Sent"
                                    value={
                                        <span>
                                            {moment(moment.utc(card.emailsent))
                                                .local()
                                                .format('MM/DD/YYYY')}
                                            &nbsp;&nbsp;&nbsp;
                                            {moment(moment.utc(card.emailsent))
                                                .local()
                                                .format('h:mm A')}
                                        </span>
                                    }
                                />
                            </Col>
                            {card.personalmessage ? (
                                <TextGroup label="Message" value={card.personalmessage} />
                            ) : (
                                <Col />
                            )}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Card>
    );
};

export default CardWrapper(CardDesktop);
